import React from 'react'

import { customFieldMap } from './components/RfField'

export const addFieldKind = (key, Component) => {
  customFieldMap[key] = (field, autoFocus) => <Component name={field.name} field={field} autoFocus={autoFocus} />
}